import config from "flow/config";

function cleanUrl() {
    const url = window.location.toString();
    const queryParams = new URLSearchParams(window.location.search);
    let continueUrl = queryParams.get(config.urlParams.continueUrl);
    const forceSingleModule =
        queryParams.get(config.urlParams.singleModule) ?? queryParams.get(config.urlParams.forceSingleModule);

    const cleanUrl = url.split(/[?#]/)[0];

    const query = forceSingleModule ? `?${config.urlParams.singleModule}=${forceSingleModule}` : "";

    let hash = window.location.hash.toString();
    hash = hash !== "" ? hash : "#";
    const proposedUrl = cleanUrl + query + hash;

    if (continueUrl) {
        continueUrl = decodeURIComponent(continueUrl);
        window.history.replaceState({}, "", cleanUrl + query + "#/" + continueUrl);
    } else if (url !== proposedUrl) {
        window.history.replaceState({}, "", proposedUrl);
    }
}

export default cleanUrl;
